import React, { useEffect } from "react";

import "react-redux-notify/dist/ReactReduxNotify.css";

import { Notify } from "react-redux-notify";

import history from "../../common/utils/history";
import Router from "../index";
import { useDispatch } from "react-redux";
import profileThunks from "../../pages/Profile/redux/thunks";

import ContactSupport from "../../common/components/ContactSupport";

import ReactGA from "react-ga";
import { hotjar } from "react-hotjar";

const NavigationAuth = ({ authUser }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (authUser) {
      localStorage.removeItem("inviteId");
      hotjar.identify("USER_ID", { userProperty: authUser.uid });
      ReactGA.set({
        userId: authUser.uid,
        userEmail: authUser.email,
      });
      dispatch(profileThunks.getProfile(authUser.uid));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Router history={history} />
      <ContactSupport />
      <Notify />
    </>
  );
};

export default NavigationAuth;
